import { Component, Input, SimpleChanges } from '@angular/core';
import { DynamicComponent } from '@dice/app/types/dynamic-component.type';
import { HeaderContent } from '@dice/app/types/table.types';

@Component({
  selector: 'table-header',
  templateUrl: './table-header.component.html',
  standalone: false,
})
export class TableHeaderComponent<T> {
  @Input() element?: T;

  @Input() header?: HeaderContent;

  dynamicComponent: DynamicComponent;

  ngOnChanges(changes: SimpleChanges): void {
    const { header, element } = changes;
    if (!!header && header.firstChange && !!element) {
      this.createDynamicComponent();
    }
  }

  private createDynamicComponent(): void {
    const { element } = this;
    const isHeader = true;
    const inputs = { element, isHeader, ...this.header };
    const outputs = {};
    const { type } = this.header;
    this.dynamicComponent = { type, component: type, inputs, outputs };
  }
}
